import { MouseEvent } from 'react';
import cn from 'classnames';
import Icon from '@components/Icon/Icon';
import { FCX } from "@datassential/platform-ui-lib";

type ActionIconProps = {
    isDisabled?: boolean;
    tooltip?: string;
    onClick?: (e: MouseEvent<HTMLDivElement>) => void;
}

const ActionIcon: FCX<ActionIconProps> = ({
    isDisabled = false,
    tooltip = '',
    children,
    onClick,
    className,
}) => {
    return (
        <div
            className={cn(
                'ActionIcon',
                !isDisabled && 'is-active',
                className,
            )}
            onClick={onClick}
        >
            <Icon type="small">{children}</Icon>
            {!!tooltip && (
                <div className="ActionIcon__tooltip">{tooltip}</div>
            )}
        </div>
    );
};

export default ActionIcon;
